import { csrfFetch } from "../utils/csrfFetch";
// import { restoreCSRF } from "../utils/csrfFetch";
// Action Types
const LOAD_TRUCKS = "trucks/LOAD_TRUCKS";
const CREATE_TRUCK = "trucks/CREATE_TRUCK";
const EDIT_TRUCK = "trucks/EDIT_TRUCK";
const DELETE_TRUCK = "trucks/DELETE_TRUCK";

// Action Creators
export const loadTrucks = (trucks) => ({
  type: LOAD_TRUCKS,
  payload: trucks,
});

const createTruck = (truck) => ({
  type: CREATE_TRUCK,
  payload: truck,
});

const editTruck = (truck) => ({
  type: EDIT_TRUCK,
  payload: truck,
});

const deleteTruck = (truckId) => ({
  type: DELETE_TRUCK,
  payload: truckId,
});

// Thunks
export const fetchTrucksAdmin = () => async (dispatch) => {
  const response = await csrfFetch("/api/trucks");
  if (response.ok) {
    const trucks = await response.json();
    dispatch(loadTrucks(trucks));
  }
};

export const fetchTrucksUser = (accountId) => async (dispatch) => {
  try {
    let url = '/api/trucks/';
    if (accountId) {
      url += `?account_id=${accountId}`;
    }

    const response = await csrfFetch(url);

    if (response.ok) {
      const trucks = await response.json();
      dispatch(loadTrucks(trucks));
      return trucks;
    } else {
      const error = await response.json();
      throw new Error(error.error || 'Failed to fetch trucks');
    }
  } catch (error) {
    console.error('Error fetching trucks:', error);
    throw error;
  }
};

export const createTruckAdmin = (truckData) => async (dispatch) => {
  try {
    console.log('Sending truck data:', truckData);

    const response = await csrfFetch('/api/trucks/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...truckData,
        account_id: parseInt(truckData.account_id)
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw error;
    }

    const newTruck = await response.json();
    dispatch(createTruck(newTruck));
    return newTruck;
  } catch (error) {
    console.error('Error in createTruckAdmin:', error);
    throw error;
  }
};

export const updateTruck = (truckData) => async (dispatch) => {
  try {
    // Remove the csrf_token and format the data
    const { csrf_token, ...cleanData } = truckData;

    // Don't lowercase the type since it needs to match exactly
    const formattedData = {
      ...cleanData,
      type: cleanData.type,
      year: parseInt(cleanData.year),
      account_id: parseInt(cleanData.account_id)
    };

    const response = await csrfFetch(`/api/trucks/${truckData.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formattedData)
    });

    if (!response.ok) {
      const error = await response.json();
      if (error.errors) {
        throw new Error(error.errors.join(', '));
      }
      throw new Error('Failed to update truck');
    }

    const updatedTruck = await response.json();
    dispatch(editTruck(updatedTruck));
    return updatedTruck;
  } catch (error) {
    console.error('Error in updateTruck:', error);
    throw error;
  }
};

export const deleteTruckAdmin = (truckId) => async (dispatch) => {
  try {
    const response = await csrfFetch(`/api/trucks/${truckId}`, {
      method: 'DELETE',
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Failed to delete truck');
    }

    dispatch(deleteTruck(truckId));
    return data;
  } catch (error) {
    console.error('Error deleting truck:', error);
    throw error;
  }
};

export const getTruckById = (id) => async (dispatch) => {
  try {
    const response = await csrfFetch(`/api/trucks/${id}`);
    if (!response.ok) {
      throw new Error('Failed to fetch truck');
    }
    const truck = await response.json();
    dispatch(editTruck(truck));
    return truck;
  } catch (error) {
    console.error('Error fetching truck:', error);
    throw error;
  }
};

// Reducer
const initialState = [];

export default function trucksReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_TRUCKS:
      return action.payload;
    case CREATE_TRUCK:
      return [...state, action.payload];
    case EDIT_TRUCK:
      return state.map(truck => truck.id === action.payload.id ? action.payload : truck);
    case DELETE_TRUCK:
      return state.filter(truck => truck.id !== action.payload);
    default:
      return state;
  }
}
